// ARCHIVO: src/components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Forzamos el scroll al inicio cada vez que la ruta cambie
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
/*<!--© 2026 Todos los derechos reservados Desarrollado por JEMAprod-Tecnologia-->*/